// Doc https://material-table.com/#/docs/all-props https://github.com/mbrn/material-table

import React, { Fragment, useState, useEffect } from "react";
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MaterialTable, { MTableToolbar } from "material-table";
import { withStyles } from '@material-ui/core/styles';
import * as H from 'helper';

const Top10ByOwnerTable = ({
    title,
    loading,
    dataByCountry,
    selectedCurrency,
    depPrice,
    columLbl,
    totalCount,
    usernNameWidth=100,
    pmIdWidth=150,
    currency=false,
    is100Rank=false,
}) => {
    const [geoData, setGeoData] = useState([]);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        let totalNum = totalCount;
        let dataArray = [], dataObj = {};
        for (let i=0; i<dataByCountry.length; i++) {
            dataObj.no = i+1;
            dataObj.url = dataByCountry[i]['country'] === '(not set)' ? false : H.CountryHelper.getCountryCode(dataByCountry[i]['country']);
            dataObj.username = dataByCountry[i]['username'];
            dataObj.pmid = dataByCountry[i]['pmid'];
            dataObj.country = dataByCountry[i]['country'];
            dataObj.num_scholar = dataByCountry[i]['numScholar'];
            dataObj.num_amulet = dataByCountry[i]['numAmulet'];
            dataObj.num_amount = handleCurrencyConvert(dataByCountry[i]['value']);
            dataObj.num_ratio = (dataByCountry[i]['value'] / totalNum * 100).toFixed(2);
            dataArray.push(dataObj);
            dataObj = {};
        }
        setGeoData(dataArray);
    }, [dataByCountry, totalCount, selectedCurrency]);

    useEffect(() => {
        setLoading(loading);
    }, [loading]);

    const handleCurrencyConvert = (amount) => {
        let returnAmount = Number(amount);
        if (selectedCurrency === 'usd') {
            returnAmount = returnAmount * depPrice.usd;
        } else if (selectedCurrency === 'sgd') {
            returnAmount = returnAmount * depPrice.sgd;
        } else if (selectedCurrency === 'jpy') {
            returnAmount = returnAmount * depPrice.jpy;
        }
        return returnAmount;
    };

    const getPrefix = (selectedCurrency) => {
        if (selectedCurrency === 'usd') {
            return "US$";
        } else if (selectedCurrency === 'sgd') {
            return "S$";
        } else if (selectedCurrency === 'jpy') {
            return "¥"
        } else {
            return "";
        }
    }

    const getColumnData = () => {
        if (is100Rank) {
            return [
                { title: '#', field: 'no', width: 50, cellStyle: {textAlign:'center'}},
                { title: 'Username', field: 'username', width: usernNameWidth, cellStyle: {textAlign:'left'}},
                { title: 'PMID', field: 'pmid', width: pmIdWidth, cellStyle: {textAlign:'left'}},
                { title: '国', field: 'country', width: 100,
                    render: rowData => <Fragment>
                                            <div style={{display:'flex'}}>
                                                <div>
                                                    {rowData.url &&
                                                    <img src={rowData.url} style={{paddingTop: 2, paddingRight: 8, width: 24}}/>
                                                    }
                                                </div>
                                                <div style={{paddingTop: 4}}>{rowData.country}</div>
                                            </div>
                                        </Fragment>
                },
                { title: 'スカラー数', field: 'num_scholar', width: 100, type: 'numeric', cellStyle: {textAlign:'center'},
                    render: rowData => <div>{H.FormatNumStrHelper.formatCommaThousand(rowData.num_scholar)}</div>
                },
                { title: 'アミュレット数', field: 'num_amulet', width: 100, type: 'numeric', cellStyle: {textAlign:'center'},
                    render: rowData => <div>{H.FormatNumStrHelper.formatCommaThousand(rowData.num_amulet)}</div>
                },
                { title: columLbl, field: 'num_amount', width: 200, type: 'numeric', cellStyle: {textAlign:'center'},
                    render: rowData => <div>{currency ? getPrefix(selectedCurrency) : ""}
                        {H.FormatNumStrHelper.formatCommaThousand(rowData.num_amount)}
                        </div>
                },
                { title: '全体比率',field: 'num_ratio', type: 'numeric', cellStyle: {textAlign:'left', marginLeft: 32},
                    render: rowData => <Fragment>
                                            <div style={{display:'flex', height: 16}}>
                                                <div style={{paddingRight: 16, width: 24}}>{rowData.num_ratio}%</div>
                                                <div style={{backgroundColor: '#65C9A5', width:rowData.num_ratio+'%', marginLeft: 20, marginTop:3}}></div>
                                            </div>
                                        </Fragment>
                },
            ]
        } else {
            return [
                { title: '#', field: 'no', width: 50, cellStyle: {textAlign:'center'}},
                { title: 'Username', field: 'username', width: usernNameWidth, cellStyle: {textAlign:'left'}},
                { title: 'PMID', field: 'pmid', width: pmIdWidth, cellStyle: {textAlign:'left'}},
                { title: '国', field: 'country', width: 100,
                    render: rowData => <Fragment>
                                            <div style={{display:'flex'}}>
                                                <div>
                                                    {rowData.url &&
                                                    <img src={rowData.url} style={{paddingTop: 2, paddingRight: 8, width: 24}}/>
                                                    }
                                                </div>
                                                <div style={{paddingTop: 4}}>{rowData.country}</div>
                                            </div>
                                        </Fragment>
                },
                { title: columLbl, field: 'num_amount', width: 200, type: 'numeric', cellStyle: {textAlign:'center'},
                    render: rowData => <div>{currency ? getPrefix(selectedCurrency) : ""}
                        {H.FormatNumStrHelper.formatCommaThousand(rowData.num_amount)}
                        </div>
                },
                { title: '全体比率',field: 'num_ratio', type: 'numeric', cellStyle: {textAlign:'left', marginLeft: 32},
                    render: rowData => <Fragment>
                                            <div style={{display:'flex', height: 16}}>
                                                <div style={{paddingRight: 16, width: 24}}>{rowData.num_ratio}%</div>
                                                <div style={{backgroundColor: '#65C9A5', width:rowData.num_ratio+'%', marginLeft: 20, marginTop:3}}></div>
                                            </div>
                                        </Fragment>
                },
            ]
        }
    }

    return(
        <MaterialTable
            isLoading={isLoading}
            style={{padding: 16, fontSize: 14, minHeight: 580}}
            title={<div style={{fontSize: 18, fontWeight: 500, color: '#000'}}>{title}</div>}
            columns={getColumnData(is100Rank)}
            data={geoData}
            options={{
                search: false,
                paging: false,
                sorting: false,
                rowStyle: {
                    textAlign:'center',
                },
                headerStyle: {textAlign:'center'}
            }}
            localization={{
                body: {
                    emptyDataSourceMessage: '表示可能なデータがありません',
                },
            }}
        />
    )
};

Top10ByOwnerTable.propTypes = {
    classes: PropTypes.object,
};

const mapStateToProps = state => ({
    selectedCurrency: state.page.selectedCurrency,
    depPrice: state.page.depPrice,
});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(null, { withTheme: true })(Top10ByOwnerTable));
